<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/BeerClaim/Claim'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-edit"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    id="bcSearch"
                    name="bcSearch"
                    v-model="bcSearch"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจากเลขที่เคลม เลขที่ Invoice หรือ หมายเลข BARCODE"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่เริ่มต้น:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="bcStartDate"
                      name="bcStartDate"
                      ref="bcStartDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่สิ้นสุด:</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="bcEndDate"
                      name="bcEndDate"
                      ref="bcEndDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทการเคลม:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'bcClaimTypeCode'"
                    :name="'bcClaimTypeCode'"
                    :select2-options="bcClaimTypeCodeOptions"
                    v-model="bcClaimTypeCode"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะการเคลม:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'bcClaimStatusCode'"
                    :name="'bcClaimStatusCode'"
                    :select2-options="bcClaimStatusCodeOptions"
                    v-model="bcClaimStatusCode"
                    ref="bcClaimStatusCodeSelect2"
                  ></select2>
                  <span class="form-text"></span>
                  <label class="kt-checkbox kt-checkbox--brand" v-if="this.$root.canShow(['ADMIN_BEER_CLAIM','MANAGER_BEER_CLAIM'])">
                    <input type="checkbox" v-model="bcClaimStatusCancel" v-bind:value="false" />
                    แสดงใบคำร้องขอเคลมเบียร์สด สถานะยกเลิกแจ้งเคลม
                    <span></span>
                  </label>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4" v-if="this.$root.canShow(['LAB_BEER_CLAIM', 'ADMIN_PLANT_BEER_CLAIM', 'MANAGER_BEER_CLAIM', 'ADMIN_BEER_CLAIM', 'PLANT_ACCOUNTANT_BEER_CLAIM'])">
                <div class="form-group">
                  <label>เลือกตรวจสอบใบเคลม/เลือกปริ้นใบ CCR:</label>
                  <treeselect
                    v-model="bcClaimShowDocCCR"
                    :multiple="false"
                    :options="bcClaimShowDocCCROptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="Claim/Add"
                  tag="button"
                  title="เพิ่มข้อมูล"
                  class="btn btn-outline-brand"
                  v-if="
                    this.$root.canShow([
                      // 'ADMIN_BEER_CLAIM',
                      'AGENT_ADMIN_BEER_CLAIM',
                    ])
                  "
                >
                  <i class="fa fa-plus-circle"></i> เพิ่มข้อมูล
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="claimTable"
              >
                <thead>
                  <tr>
                    <th class="all">เลขที่เคลม</th>
                    <th class="all">ประเภทการเคลม</th>
                    <th class="all text-center">ชื่อผู้เคลม</th>
                    <th class="all">เลขที่ Invoice</th>
                    <th class="all">BARCODE</th>
                    <th class="all">รหัสทรัพย์สิน(เบียร์สด)</th>
                    <th class="all">สถานะการเคลม</th>
                    <th class="all">วันที่เคลม</th>
                    <th class="all">เอกสาร</th>
                    <th class="all">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import select2 from "../../Shared/Select2";
import router from "../../router";
import analyzeSpecifyForm from "./AnalyzeSpecifyForm";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

//กรณีมีปุ่มให้กดยืนยัน
// <a href="#" @click.prevent="showShowReqApproval" v-if="data.showShowReqApproval" title="ยืนยันผลการเคลม" class="btn btn-sm btn-clean btn-icon btn-icon-md">
//   <i class="fas flaticon-interface-5"></i>
// </a>
let BeerClaimActions = Vue.extend({
  template: `
  <div style="display: flex; flex-direction: row; align-items: center; justify-content: center">
    <a href="#" @click.prevent="detailBeerClaim" v-if="data.showDetailButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon">
      <i class="la la-file-text"></i>
    </a>
    <a href="#" @click.prevent="showDocRequest" title="ใบคำร้องขอเคลมเบียร์สด" class="btn btn-sm btn-clean btn-icon">
      <i class="la la-print" style="color: #800080"></i>
    </a>
    <a href="#" @click.prevent="editBeerClaim" v-if="data.showEditButton" title="แก้ไข" class="btn btn-sm btn-clean btn-icon">
      <i class="la la-edit"></i>
    </a>
    <a href="#" @click.prevent="editStatusQIBeerClaim" v-if="data.showEditStatusQIButton" title="เปลี่ยนสถานะ (เจ้าหน้าที่ QC ตรวจสอบ)" class="btn btn-sm btn-clean btn-icon">
      <i class="fas flaticon-interface-4"></i>
    </a>
    <a href="#" @click.prevent="editStatusAnalyzeDeliver" v-if="data.showEditStatusAnalyzeDeliver" title="เปลี่ยนสถานะ (ส่งวิเคราะห์น้ำเบียร์)" class="btn btn-sm btn-clean btn-icon">
      <i class="fas flaticon-interface-4"></i>
    </a>
    <a href="#" @click.prevent="showAnalyzeSpecifyForm" v-if="data.showEditStatusAnalyzeSpecify" title="เปลี่ยนสถานะ (ระบุผลการวิเคราะห์)" class="btn btn-sm btn-clean btn-icon">
      <i class="fas flaticon-interface-4"></i>
    </a>
    <!--<a href="#" @click.prevent="showAnalyzeResultForm" v-if="data.showEditStatusAnalyzeResult" title="เปลี่ยนสถานะ (ส่งผลการวิเคราะห์)" class="btn btn-sm btn-clean btn-icon">
      <i class="fas flaticon-interface-4"></i>
    </a>-->
    <a href="#" @click.prevent="commitBeerClaim" v-if="data.showCommitButton" title="สามารถส่งเคลมได้" class="btn btn-sm btn-clean btn-icon">
      <i class="flaticon-list"></i>
    </a>
    <a href="#" @click.prevent="showApprove" v-if="data.showApprove" title="อนุมัติการเคลม" class="btn btn-sm btn-clean btn-icon">
      <i class="fas flaticon-interface-5"></i>
    </a>
    <a href="#" @click.prevent="showConclude" v-if="data.showConclude" title="สรุปผลการอนุมัติและชดเชย" class="btn btn-sm btn-clean btn-icon">
      <i class="fas flaticon-interface-5"></i>
    </a>
    <a href="#" @click.prevent="resultBeerClaim" v-if="data.showResult" title="ผลการอนุมัติการเคลม" class="btn btn-sm btn-clean btn-icon">
      <i class="flaticon-list-3"></i>
    </a>
    <a href="#" @click.prevent="editStatusCancel" v-if="data.checkStatusforCancel" title="ยกเลิกแจ้งเคลม" class="btn btn-sm btn-clean btn-icon">
      <i class="la la-trash" style="color:Red"></i>
    </a>
    <analyze-specify-form ref="analyzeSpecifyForm"></analyze-specify-form>
  </div>`,
  components: {
    analyzeSpecifyForm,
  },
  methods: {
    detailBeerClaim: function() {
      router.push({
        path: `/BeerClaim/Claim/Detail/${this.data.claimId}`,
      });
    },
    showDocRequest: function() {
      var rootPath = "https://" + window.location.host;
      window.open(rootPath + "/Print/BeerClaimRequest/" + this.data.claimId);
    },
    editBeerClaim: function() {
      router.push({
        path: `/BeerClaim/Claim/Edit/${this.data.claimId}`,
      });
    },
    commitBeerClaim: function() {
      router.push({
        path: `/BeerClaim/Claim/Commit/${this.data.claimId}`,
      });
    },
    showApprove: function() {
      router.push({
        path: `/BeerClaim/Claim/Approve/${this.data.claimId}`,
      });
    },
    showConclude: function() {
      router.push({
        path: `/BeerClaim/Claim/Conclude/${this.data.claimId}`,
      });
    },
    resultBeerClaim: function() {
      router.push({
        path: `/BeerClaim/Claim/Result/${this.data.claimId}`,
      });
    },
    editStatusQIBeerClaim: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งการเปลี่ยนสถานะเบียร์เคลม",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งการเปลี่ยนสถานะเบียร์เคลม <strong>" + "</strong>",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการเปลี่ยนสถานะเบียร์เคลม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังเปลี่ยนสถานะเบียร์เคลม กรุณารอสักครู่...",
          });
          axios
            .put("/Api/BeerClaim/EditStatus", {
              ClaimItemId: this.data.claimItemId,
              StatusCode: "CLAIM_STATUS_QI_INSPECT",
            })
            .then(function(response) {
              // console.log("response ", response);
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    editStatusAnalyzeDeliver: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งการเปลี่ยนสถานะเบียร์เคลม",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งการเปลี่ยนสถานะเบียร์เคลม <strong>" + "</strong>",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการเปลี่ยนสถานะเบียร์เคลม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังเปลี่ยนสถานะเบียร์เคลม กรุณารอสักครู่...",
          });
          axios
            .put("/Api/BeerClaim/EditStatus", {
              ClaimItemId: this.data.claimItemId,
              StatusCode: "CLAIM_STATUS_BEER_ANALYZE_DELIVER",
            })
            .then(function(response) {
              //console.log("response ", response);
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
    showAnalyzeSpecifyForm: function() {
      $(this.$refs.analyzeSpecifyForm.$el).modal("show");
    },
    showAnalyzeResultForm: function() {
      let self = this;
      $(this.$refs.analyzeSpecifyForm.$el)
        .on("hidden.bs.modal", function() {
          // Set go back
          //router.go(-1);
          self.$parent.reloadDataTable();
        })
        .modal("show");
    },
    //กรณีมีปุ่มให้กดยืนยัน
    // showShowReqApproval: function() {
    //   let self = this;
    //   Swal.fire({
    //     title: "คำสั่งการยืนยันผลการเคลม",
    //     type: "warning",
    //     html: "กรุณายืนยันคำสั่งการยืนยันผลการเคลม <strong>" + "</strong>",
    //     input: this.data.userCount > 0 ? "checkbox" : "",
    //     inputValue: 0,
    //     inputPlaceholder: "ต้องการยืนยันผลการเคลม",
    //     showCancelButton: true,
    //     confirmButtonText: "ยืนยัน",
    //     cancelButtonText: "ยกเลิก",
    //     showLoaderOnConfirm: true,
    //   }).then((result) => {
    //     if (result.value) {
    //       KTApp.blockPage({
    //         opacity: 0.05,
    //         message: "กำลังยืนยันผลการเคลม กรุณารอสักครู่...",
    //       });
    //       axios
    //         .post("/Api/BeerClaim/ConfirmJobRequestApproval", {
    //           ClaimId: this.data.claimId,
    //         })
    //         .then(function(response) {
    //           //console.log("response ", response);
    //           if (response.data.data) {
    //             self.$parent.reloadDataTable();
    //             Swal.fire("สำเร็จ", response.data.message, "success");
    //           } else {
    //             Swal.fire(
    //               "เกิดข้อผิดพลาด",
    //               error.response.data.message,
    //               "error"
    //             );
    //           }
    //         })
    //         .catch(function(error) {
    //           Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
    //         })
    //         .then(function() {
    //           // always executed
    //           KTApp.unblockPage();
    //         });
    //     }
    //   });
    // },
    editStatusCancel: function() {
      let self = this;
      Swal.fire({
        title: "คำสั่งยกเลิกข้อมูลใบงาน",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งยกเลิกข้อมูลใบคำร้อง<br/>ขอเคลมเบียร์สด <strong>" +this.data.claimNumber+ "</strong>",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องยกเลิกการแจ้งเคลม",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังยกเลิกการแจ้งเคลม กรุณารอสักครู่...",
          });
          axios
            .put("/Api/BeerClaim/EditStatus", {
              ClaimItemId: this.data.claimItemId,
              StatusCode: "CLAIM_STATUS_CANCEL",
            })
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    },
  },
});

let BeerClaimDocActions = Vue.extend({
  template: `
  <div style="display: flex; flex-direction: row; align-items: center; justify-content: center">
    <a href="#" @click.prevent="showDocHold" v-if="data.showDocHold" title="ใบ Hold" class="btn btn-sm btn-clean btn-icon">
      <i class="flaticon-file-2 iconsize"></i>
    </a>
    <a href="#" @click.prevent="showDocHoldAdd" v-if="data.showDocHoldAdd" title="ใบ Hold" class="btn btn-sm btn-clean btn-icon">
      <i class="flaticon-file-2 iconsize"></i>
    </a>
    <a href="#" @click.prevent="showDocCCR" v-if="data.showDocCCR" title="ใบ CCR" class="btn btn-sm btn-clean btn-icon">
      <i class="flaticon-list-1 iconsize" style="color:Gold"></i>
    </a>
    <a href="#" @click.prevent="showDocApprove" v-if="data.showDocApprove" title="แจ้งผลอนุมัติการเคลม" class="btn btn-sm btn-clean btn-icon">
      <i class="flaticon-interface-10 iconsize" style="color:Green"></i>
    </a>
    <a href="#" @click.prevent="showDocReject" v-if="data.showDocReject" title="แจ้งผลไม่อนุมัติการเคลม" class="btn btn-sm btn-clean btn-icon">
      <i class="flaticon-interface-11 iconsize" style="color:Red" ></i>
    </a>
  </div>`,
  methods: {
    showDocHold: function() {
      var rootPath = "https://" + window.location.host;
      window.open(rootPath + "/Print/Hold/" + this.data.claimId);
    },
    showDocHoldAdd: function() {
      var rootPath = "https://" + window.location.host;
      window.open(rootPath + "/Print/Holdadd/" + this.data.claimId);
    },
    showDocCCR: function() {
      var rootPath = "https://" + window.location.host;

      var type = this.data.claimStatusCode;
      window.open(
        rootPath + "/Print/CcrForm?Id=" + this.data.claimId + "&type=" + type
      );
    },
    showDocApprove: function() {
      var rootPath = "https://" + window.location.host;
      window.open(rootPath + "/Print/Approval/" + this.data.claimId);
    },
    showDocReject: function() {
      var rootPath = "https://" + window.location.host;
      window.open(rootPath + "/Print/DisApproval/" + this.data.claimId);
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      bcSearch: null,
      bcClaimTypeCode: null,
      bcClaimStatusCode: null,
      bcStartDate: null,
      bcEndDate: null,
      bcClaimShowDocCCR: "WorkMe",
      bcClaimShowDocCCROptions: [],
      bcClaimStatusCancel: false,
      bcClaimShowDocCCRTemp: "WorkMe",

      // Configurations
      bcClaimTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "BEER_CLAIM_TYPE",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      bcClaimStatusCodeOptions: {
        placeholder: "กรุณาเลือกสถานะการเคลม",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/BeerClaim/Options",
          data: function(params) {
            var query = {
              IsCheck: self.bcClaimShowDocCCR,
              search: "CLAIM_STATUS",
              KeySearch: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formReset: function(e) {
      let self = this;
      self.bcSearch = null;
      self.bcStartDate = null;
      self.bcEndDate = null;
      self.bcClaimTypeCode = null;
      self.bcClaimStatusCode = null;
      self.bcClaimShowDocCCR = "WorkMe";
      self.bcClaimStatusCancel = false;

      $("#bcStartDate")
        .val("")
        .trigger("change");

      $("#bcEndDate")
        .val("")
        .trigger("change");

      $("#bcClaimTypeCode")
        .val("")
        .trigger("change");

      $("#bcClaimStatusCode")
        .val("")
        .trigger("change");

      $("#bcClaimShowDocCCR")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#claimTable").DataTable();
      table.search();
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#claimTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    Select2CCROptions(index) {
      let self = this;
      self.bcClaimShowDocCCROptions = [];
      if (self.$root.canShow(["ADMIN_BEER_CLAIM"])) {
        self.bcClaimShowDocCCROptions = [
          {id: "WorkMe", label: "เลือกตรวจสอบใบเคลม"},
          {id: "ShowCCR", label: "เลือกปริ้นใบ CCR"},
          // {id: "All", label: "เลือกทั้งหมด"}
        ];
      }
      else {
        self.bcClaimShowDocCCROptions = [
          {id: "WorkMe", label: "เลือกตรวจสอบใบเคลม"},
          {id: "ShowCCR", label: "เลือกปริ้นใบ CCR"},
        ];
      }
    },
  },
  async mounted() {
    let self = this;

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.bcStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.bcStartDate)
      .datepicker(
        "update",
        !!self.bcStartDate ? self.bcStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.bcStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.bcEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reEndDate = moment().endOf('month');
    $(self.$refs.bcEndDate)
      .datepicker(
        "update",
        !!self.bcEndDate ? self.bcEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.bcEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    self.Select2CCROptions();

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#claimTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/BeerClaim/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                SearchKeyword: self.bcSearch,
                StartDate:
                  self.bcStartDate != null
                    ? self.bcStartDate.format("DD/MM/YYYY")
                    : self.bcStartDate,
                EndDate:
                  self.bcEndDate != null
                    ? self.bcEndDate.format("DD/MM/YYYY")
                    : self.bcEndDate,
                ClaimStatusCancel: self.bcClaimStatusCancel,
                ClaimTypeCode: self.bcClaimTypeCode,
                ClaimStatusCode: self.bcClaimStatusCode,
                ClaimShowDocCCR: self.bcClaimShowDocCCR
              })
            );
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },

        // Order settings
        order: [[7, "desc"]],
        columns: [
          {
            data: "claimNumber",
            className: "text-center",
          },
          {
            data: "claimTypeCode",
            className: "text-center",
            width: "10%",
            render: function(data, type, full, meta) {
              return full.claimTypeName;
            },
          },
          {
            data: "claimAgentName",
            width: "20%",
            render: function(data, type, full, meta) {
              return full.claimAgentName != null
                ? full.claimAgentName
                : full.claimShopName;
            },
          },
          {
            data: "invoice",
            className: "text-center",
          },
          {
            data: "barcodeNumberOld",
            className: "text-center",
          },
          {
            data: "departmentMaterialCode",
            className: "text-center",
          },
          {
            data: "claimStatusCode",
            className: "text-center",
            width: "15%",
            render: function(data, type, full, meta) {
              if (full.claimStatusCode == "CLAIM_STATUS_CANCEL") {
                return ('<span class="text-danger">' + full.claimStatusName + "</span>");
              }else{
                return full.claimStatusName;
              }
            },
          },
          {
            data: "claimDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.claimDateFormat;
            },
          },
          {
            data: "claimId",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="docAction"></div>';
            },
          },
          {
            data: "claimItemId",
            className: "text-center",
            width: "15%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showDetailButton = self.$root.canShow([
              "AGENT_ADMIN_BEER_CLAIM",
              "QI_OFFICER_BEER_CLAIM",
              "PLANT_ACCOUNTANT_BEER_CLAIM",
              "LAB_BEER_CLAIM",
              "MANAGER_BEER_CLAIM",
              "ADMIN_BEER_CLAIM",
            ]);
            data.showEditButton =
              (self.$root.canShow(["AGENT_ADMIN_BEER_CLAIM"]) && data.claimStatusCode == "CLAIM_STATUS_SUBMIT")
              || (self.$root.canShow(["ADMIN_BEER_CLAIM"]));
            data.showEditStatusQIButton =
              self.$root.canShow([
                // "ADMIN_BEER_CLAIM",
                "QI_OFFICER_BEER_CLAIM",
              ]) 
              && data.claimStatusCode == "CLAIM_STATUS_SUBMIT";
            data.showEditStatusAnalyzeDeliver =
              self.$root.canShow([
                // "ADMIN_BEER_CLAIM",
                "PLANT_ACCOUNTANT_BEER_CLAIM",
              ]) && data.claimStatusCode == "CLAIM_STATUS_BEER_DELIVER";
            data.showEditStatusAnalyzeSpecify =
              self.$root.canShow([
                // "ADMIN_BEER_CLAIM", 
                "LAB_BEER_CLAIM"
                ]) &&
              data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_DELIVER";
            data.showEditStatusAnalyzeResult =
              self.$root.canShow([
                // "ADMIN_BEER_CLAIM",
                "PLANT_ACCOUNTANT_BEER_CLAIM",
              ]) && data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_SPECIFY";
            //กรณีมีปุ่มให้กดยืนยัน
            // data.showShowReqApproval =
            //   self.$root.canShow(["ADMIN_BEER_CLAIM"]) &&
            //   data.isShowReqApproval;
            // data.showDeleteButton = self.$root.canShow([
            //   "ADMIN_PM",
            //   "USER_PM"
            // ]);
            data.showCommitButton =
              self.$root.canShow(["QI_OFFICER_BEER_CLAIM"]) &&
              data.claimStatusCode == "CLAIM_STATUS_QI_INSPECT";
            data.showApprove =
              self.$root.canShow(["MANAGER_BEER_CLAIM"]) &&
              ((data.claimStatusCode == "CLAIM_STATUS_WARE_DELIVER" &&
                data.preApproveStatus != null) ||
                data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_APPROVE");
            data.showConclude =
              self.$root.canShow(["ADMIN_BEER_CLAIM"]) &&
              (data.claimStatusCode == "CLAIM_STATUS_APPROVE" ||
                data.claimStatusCode == "CLAIM_STATUS_REJECT");

            data.showResult =
              (self.$root.canShow(["AGENT_ADMIN_BEER_CLAIM"]) &&
                (data.claimStatusCode == "CLAIM_STATUS_REVOKE" ||
                  data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE" ||
                  data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_REJECT")
              ) || (self.$root.canShow(["ADMIN_BEER_CLAIM"]) && data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE");

            if (self.$root.canShow(["ADMIN_BEER_CLAIM"]) && 
              !["CLAIM_STATUS_APPROVE"
                  , "CLAIM_STATUS_CONCLUDE_APPROVE"
                  , "CLAIM_STATUS_CONCLUDE_REJECT"
                  , "CLAIM_STATUS_REJECT"
                  , "CLAIM_STATUS_CANCEL"
              ].includes(data.claimStatusCode)
            ) {
              data.checkStatusforCancel = true;
            } else {
              data.checkStatusforCancel = false;
            }

            new BeerClaimActions({ data: { data }, parent: self }).$mount(el);
          }
        }),
          $(".docAction").each(function(i, el) {
            var $dt = table.DataTable();
            var $tr = $(el)
              .parents("tr")
              .first();
            var data = $dt.row($tr).data();
            if (data) {
              data.showDocHold =
                self.$root.canShow([
                  "ADMIN_BEER_CLAIM",
                  "COMPANY_PROFILE_TYPE_AGENT",
                  "AGENT_ADMIN_BEER_CLAIM",
                  "QI_OFFICER_BEER_CLAIM",
                  "PLANT_ACCOUNTANT_BEER_CLAIM",
                  "ADMIN_PLANT_BEER_CLAIM",
                  "MANAGER_BEER_CLAIM",
                  "LAB_BEER_CLAIM",
                ]) && (data.claimStatusCode == "CLAIM_STATUS_COMMIT"
                  || data.claimStatusCode == "CLAIM_STATUS_BEER_DELIVER"
                  || data.claimStatusCode == "CLAIM_STATUS_WARE_DELIVER"
                  || data.claimStatusCode == "CLAIM_STATUS_APPROVE"
                  || data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE"
                  || data.claimStatusCode == "CLAIM_STATUS_REJECT"
                  || data.claimStatusCode == "CLAIM_STATUS_BEER_DELIVER"
                  || data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_DELIVER"
                  || data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_RESULT"
                  || data.claimStatusCode == "CLAIM_STATUS_BEER_ANALYZE_APPROVE"
                );

              data.showDocHoldAdd =
                self.$root.canShow([
                  "ADMIN_BEER_CLAIM",
                  "COMPANY_PROFILE_TYPE_AGENT",
                  "AGENT_ADMIN_BEER_CLAIM",
                ]) && data.claimStatusCode == "CLAIM_STATUS_TANK_RECEIVE";
              data.showDocCCR =
                // self.$root.canShow([
                //   "PLANT_ACCOUNTANT_BEER_CLAIM",
                //   "LAB_BEER_CLAIM",
                //   "ADMIN_BEER_CLAIM",
                //   "MANAGER_BEER_CLAIM",
                // ]) && data.labResult != null;
                self.$root.canShow([
                  "PLANT_ACCOUNTANT_BEER_CLAIM",
                  "LAB_BEER_CLAIM",
                  "ADMIN_PLANT_BEER_CLAIM",
                  "MANAGER_BEER_CLAIM",
                  "ADMIN_BEER_CLAIM"
                ]) && data.labResult != null;

              if (data.claimPrice > 0) {
                data.showDocApprove = self.$root.canShow([
                  "ADMIN_BEER_CLAIM", 
                  "MANAGER_BEER_CLAIM", 
                  "AGENT_ADMIN_BEER_CLAIM"
                  ]) && (data.claimStatusCode == "CLAIM_STATUS_APPROVE" || data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE");
              }
              else {
                data.showDocApprove = self.$root.canShow([
                  "ADMIN_BEER_CLAIM", 
                  "MANAGER_BEER_CLAIM"
                  ]) && (data.claimStatusCode == "CLAIM_STATUS_APPROVE" || data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_APPROVE");
              }
              
              data.showDocReject =
                self.$root.canShow([
                  "ADMIN_BEER_CLAIM",
                  "MANAGER_BEER_CLAIM",
                  "AGENT_ADMIN_BEER_CLAIM",
                ]) &&
                (data.claimStatusCode == "CLAIM_STATUS_REJECT" || data.claimStatusCode == "CLAIM_STATUS_CONCLUDE_REJECT");
              new BeerClaimDocActions({ data: { data }, parent: self }).$mount(
                el
              );
            }
          });
      });
  },
  watch: {
    bcClaimShowDocCCR(newval) {
      if(typeof this.$root.user.profile.role == "string"){
        if(this.$root.user.profile.role == "ADMIN_BEER_CLAIM"){
          let check = false;
          if (newval === undefined && this.bcClaimShowDocCCRTemp !== undefined) {
            check = true;
          } else if (newval !== undefined && this.bcClaimShowDocCCRTemp === undefined) {
            check = true;
          }else{
            check = false;
          }
          if(check){
            this.$refs.bcClaimStatusCodeSelect2.$el.value = '';
            $(this.$refs.bcClaimStatusCodeSelect2.$el).trigger('change');
            $(this.$refs.bcClaimStatusCodeSelect2.$el).select2('close');
          }
          this.bcClaimShowDocCCRTemp = newval
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn.btn-sm [class^="la-"], .btn-group-sm > .btn [class^="la-"], .btn.btn-sm [class*=" la-"], .btn-group-sm > .btn [class*=" la-"] {
  font-size: 1rem !important;
}
.btn.btn-icon.btn-icon-md [class^="flaticon-"], .btn.btn-icon.btn-icon-md [class*=" flaticon-"], .btn.btn-icon.btn-icon-md [class^="flaticon2-"], .btn.btn-icon.btn-icon-md [class*=" flaticon2-"] {
  font-size: 1rem !important;
}
</style>



// WEBPACK FOOTER //
// App/Components/BeerClaim/SearchBeerClaim.vue